// @deprecated
export const SRAVNI_AUTH_FRONTEND_SCOPE = [
    'openid',
    'offline_access',
    'email',
    'phone',
    'profile',
    'roles',
    'reviews',
    'esia',
    'orders.r',
    'messagesender.sms',
    'Sravni.Reviews.Service',
    'Sravni.Osago.Service',
    'Sravni.QnA.Service',
    'Sravni.FileStorage.Service',
    'Sravni.PhoneVerifier.Service',
    'Sravni.Identity.Service',
    'Sravni.VZR.Service',
    'Sravni.Affiliates.Service',
    'Sravni.News.Service',
].join(' ');
/** Список заголовков */
export const HEADERS = {
    IMAGE_VERSION: 'Image-Version',
    LOCATION: 'X-Location-Route',
    CALLER_ID: 'sravni-service-name',
};
